import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendMasterDocuments } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { SendMasterDocumentsDto } from '@dealstack/shared/lib/generated';
import { useWorkflowProgress } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/WorkflowProgress/WorkflowProgressContext';
import {
	useTranslationDefault,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';

import { useMasterDocumentsEndpoints } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentsEndpoints';
import { resolveSendErrorMessage } from './sendMasterDocuments.utils';

export const useSendMasterDocuments = () => {
	const tDefault = useTranslationDefault();
	const tMipManage = useTranslationMipManage();
	const queryClient = useQueryClient();
	const { startEmailWorkflow } = useWorkflowProgress();

	// From the same hook every other master-document mutation invalidates with, so a change to
	// the key's shape cannot leave this one silently not invalidating.
	const { list: listKey } = useMasterDocumentsEndpoints();

	return useMutation({
		mutationFn: async (args: SendMasterDocumentsDto) => await sendMasterDocuments(args),
		onSuccess: async (data) => {
			startEmailWorkflow(data.payload?.investorInviteWorkflowHandle);
			await queryClient.invalidateQueries({ queryKey: [listKey] });
		},
		onError: (error: unknown) => {
			showToastV2({
				state: 'error',
				title: resolveSendErrorMessage({ error, tDefault, tMipManage }),
			});
		},
	});
};
